import {
  POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS,
  PotentialAreasOfConcernSuggestionsType,
} from "./types/patientPreviewTypes";

export const getPreviewSuggestionsColors = (
  suggestion: PotentialAreasOfConcernSuggestionsType,
) => {
  const color = {
    [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.direct_report_skew]:
      "bg-neutral-5 text-gray-70",
    [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.personality_pathology]:
      "bg-complementary-lightblue-200 text-complementary-lightblue-950",
    [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.impulsivity]:
      "bg-complementary-purple-200 text-complementary-purple-950",
    [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.eating_disorder]:
      "bg-complementary-magenta-200 text-complementary-magenta-900",
    [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.substance_use]:
      "bg-primary-200 text-primary-800",
  };

  return color[suggestion];
};
